import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorType } from '@grid-ui/logging';
import { LoggingService } from '@maplecroft-ui/logging';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DownloadResourceService {
  constructor(
    private readonly http: HttpClient,
    private readonly loggingService: LoggingService,
  ) {}

  public download(url: string): Observable<HttpResponse<any>> {
    return this.http
      .get(url, {
        headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
        observe: 'response',
        responseType: 'blob' as 'json',
      })
      .pipe(
        catchError((error) => {
          const message = `PDF Download Failed: ${error && error.message ? error.message : url}`;
          void this.loggingService.log(message, { level: 'error', errorType: ErrorType.PDFDownload });
          return throwError(error as any);
        }),
      );
  }

  public downloadAsXlsx(url: string): Observable<Blob> {
    return this.http.get(url, {
      headers: new HttpHeaders({ Accept: 'application/vnd.ms-excel' }),
      responseType: 'blob',
    });
  }

  public getFilenameByContendDisposition(contentDisposition: string): string {
    return contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim().replace(/"/g, '');
  }
}
